// extracted by mini-css-extract-plugin
export default {"mediaHeader":"mediaHeader__92h7b","mediaPlaceholder":"mediaPlaceholder__soBSo","mediaContent":"mediaContent__gdxw+"};